export default () => {
  return {
    /**
     * Session the user is currently running through
     */
    primaryActiveSession: {},
    loadedActiveSessionPrograms: [],
    activeSessionIdPointer: null,

    activeSessionGroup: null,
    groupSessions: [],
    groupSessionPrograms: {},

    scheduledSessions: [],
    supervisingSessions: [],
    activeVideoCallSessions: [],
    videoSessionMembersNames: {},

    historyBound: false,

    sessionsHistory: [],
    incidentHistory: [],

    activeSessionProgramMods: {},
    isTrainingVideoPlaying: false,
  };
};
